'use client';

import { Skeleton } from '@skin-seoul/design-system';
import React from 'react';

export const ShoppingBagSkeleton = () => {
  const renderSkeletonProductItems = () => {
    return Array(3)
      .fill(0)
      .map((_, index) => (
        <React.Fragment key={index}>
          <div className="flex p-4 w-full flex-col gap-3">
            <div className="flex w-full gap-3">
              <Skeleton className="w-[80px] h-[80px] rounded-[8px]" />
              <div className="flex flex-col justify-between flex-1 gap-2">
                <Skeleton className="h-4 w-[70%]" />
                <Skeleton className="h-4 w-[40%]" />
                <div className="flex justify-between items-center w-full">
                  <Skeleton className="w-[80px]" />
                  <Skeleton className="w-[60px]" />
                </div>
              </div>
            </div>
          </div>
          {index < 2 && <div className="border-b border-generic-0 w-full" />}
        </React.Fragment>
      ));
  };

  return (
    <>
      <div className="items-center flex h-[72px] flex-row justify-between p-[10px] w-full pr-5" />

      <div className="p-0 w-full overflow-x-auto px-2">
        <div className="flex flex-col h-full w-full">{renderSkeletonProductItems()}</div>
      </div>

      <div className="flex flex-col gap-5 h-fit p-5 w-full bg-neutral-30">
        <div className="relative flex flex-col w-full gap-5">
          {/* Free Shipping Progress Skeleton */}
          <div className="w-full p-4 rounded-[8px] bg-white">
            <Skeleton className="h-4 w-[60%]" />
          </div>

          {/* Order Summary Skeleton */}
          <div className="w-full p-4 rounded-[8px] bg-white">
            <div className="flex justify-between mb-2">
              <Skeleton className="h-4 w-[30%]" />
              <Skeleton className="h-4 w-[20%]" />
            </div>
            <div className="flex justify-between mt-2">
              <Skeleton className="h-4 w-[30%]" />
              <Skeleton className="h-4 w-[20%]" />
            </div>
          </div>
        </div>

        {/* Checkout Button Skeleton */}
        <Skeleton className="w-full h-[48px] rounded-[8px]" />
      </div>
    </>
  );
};

export default ShoppingBagSkeleton;
